(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3629],{

/***/ 51904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_pages_prestamos_hipotecarios_alliances_section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29019);
/* harmony import */ var _components_pages_prestamos_hipotecarios_cover_section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23830);
/* harmony import */ var _components_head_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23385);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6644);
/* harmony import */ var _components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79001);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5616);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);


var _templateObject, _templateObject2, _templateObject3;











var PrestamosHipotecarios = function PrestamosHipotecarios() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var metaData = {
    title: "mortgageLoans",
    description: "mortgage-load",
    keyWords: shared_models_const_keywords_const__WEBPACK_IMPORTED_MODULE_5__/* .CKeyWordsPages.mortgageLoad */ .k.mortgageLoad,
    url: router.asPath,
    picture: "/images/image-optimize/bussiness-people.webp"
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_head_meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, metaData), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_a1_refactor_typography_WsPhantomNav__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_pages_prestamos_hipotecarios_cover_section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MainContainer, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ElementForm, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Content, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_pages_prestamos_hipotecarios_alliances_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null))));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PrestamosHipotecarios);
var MainContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-brand-cream-primary);\n  position: relative;\n  z-index: 9;\n"])));
var Content = (0,_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject2 || (_templateObject2 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 11;\n  @media (max-width: 900px) {\n    padding-top: 50px;\n  }\n"])));
var ElementForm = (0,_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject3 || (_templateObject3 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  border-radius: 200px 0px 0px 0px;\n  position: absolute;\n  z-index: 10;\n  top: -100px;\n  width: 100%;\n  min-height: 100px;\n  background-color: var(--color-brand-cream-primary);\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 900px) {\n    border-radius: 0px;\n    display: none;\n  }\n  @media (max-width: 600px) {\n  }\n"])));

/***/ }),

/***/ 50092:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestamos/hipotecarios",
      function () {
        return __webpack_require__(51904);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,8407,6877,3843,1664,1294,2888,179], function() { return __webpack_exec__(50092); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);